import { PortalModule } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';
import { ImageModule } from '@com-delta-idp/mnx-ui-kit';
import { MembershipCardComponent } from './membership-card.component';

@NgModule({
  declarations: [MembershipCardComponent],
  imports: [ImageModule, PortalModule],
  exports: [MembershipCardComponent]
})
export class MembershipCardModule {}
